import { OrderStatus, ShipStatus } from "@/graphql/codegen/graphql"

export const ORDER_STATUS_LABEL_LOOKUP: Record<OrderStatus, string> = {
  [OrderStatus.CanceledQuote]: "Quote Cancelled",
  [OrderStatus.Cancelled]: "Cancelled",
  [OrderStatus.Completed]: "Completed",
  [OrderStatus.Confirmed]: "Confirmed",
  [OrderStatus.Draft]: "Draft",
  [OrderStatus.PartiallyReceived]: "Partially Received",
  [OrderStatus.PartiallyShipped]: "Partially Shipped",
  [OrderStatus.Quote]: "Quote",
  [OrderStatus.Received]: "Received",
  [OrderStatus.Sent]: "Sent",
  [OrderStatus.Shipped]: "Shipped",
}

export const SHIPPING_STATUS_LABEL_LOOKUP: Record<ShipStatus, string> = {
  [ShipStatus.Delivered]: "Delivered",
  [ShipStatus.InTransit]: "In Transit",
  [ShipStatus.Pending]: "Pending",
}
